import React, { useEffect, useState, useContext, Fragment } from "react";

import { GoogleMaterialIcon } from '../../../ui/GoogleMaterialIcon';
import { TrackNowButton } from '../../../ui';

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { Delete } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import MuiButton from "@mui/material/Button";
import { Tooltip } from "@mui/material";
import Input from "@mui/material/Input";
import Alert from "@mui/material/Alert";

import ClientFilingMasterContext from "../../../../context/client-filing-master/ClientFilingMasterContext";
import AuthContext from "../../../../context/auth/AuthContext";

import useDialog from "../../../common/UseDialog";
import usePermission from "../../../../usePermission";
import { TrackNowTextField } from "../../../ui";
import { useCommonDetailsContext } from "../../../../context/Common/common";
import { tokens } from '../../../../theme/tokens';
import {
  fetchCalendarFilingAttachments,
  downloadCalendarFilingAttachment,
  createCalendarFilingAttachment,
  deleteCalendarFilingAttachment,
} from "./helper";

const CalendarDetailsAttachment = () => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const [isLoading, setIsLoading] = useState(false);
  const [attachmentList, setAttachmentList] = useState([]);
  const [selectAttachment, setSelectAttachment] = useState(null);
  const [selectedFile, setSelectedFile] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const authContext = useContext(AuthContext);
  const { authUser, userRoles, toLocalDateTime } = authContext;
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { selectedTrackerCalendarEvent, selectedTrackerCalendarEventDisplay } = clientFilingMasterContext;
  const [expanded, setExpanded] = useState(false);

  const handleChange = () => {
    setExpanded((prev) => !prev);
  };

  const getFilename = function (str) {
    return str ? str.replace(/^.*[\\\/]/, "") : "";
  };

  const getUserName = (userId) => {
    const user = userRoles
      ? userRoles?.filter((user) => user.userId === parseInt(userId))[0]
        ?.userName
      : "";
    return user;
  };

  const closeConfirm = () => {
    setSelectAttachment(null);
  };

  const IsDisabled = () => {
    // return !usePermission(
    //   "ClientFilingList",
    //   "addFinalAttachment",
    //   props.selectedClientId
    // );
  };

  const onFileChange = async (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (selectedFile) {
      setShowSuccess(false);
      setShowError(false);
    }
  };

  const handleCancel = async () => {
    setSelectedFile(() => null);
    setShowSuccess(false);
    setShowError(false);
    setIsLoading(false);
    const form = document.getElementById("uploadForm");
    form.reset();
  };

  const renderAttachment = (rowData) => {
    // console.log("renderAttachment", rowData);
    return (
      <MuiButton
        size="small"
        variant="text"
        style={{ fontSize: "0.8rem" }}
        onClick={() =>
          downloadFile(rowData.attachmentPath, rowData.attachmentId)
        }
      >
        <Tooltip title={getFilename(rowData.attachmentPath)}>
          {rowData.attachmentPath && getFilename(rowData.attachmentPath)}
        </Tooltip>
      </MuiButton>
    );
  };

  const downloadFile = async (attachmentPath, attachmentId) => {
    const fileName = getFilename(attachmentPath);
    const { fileTrackingId, customerId } =
      selectedTrackerCalendarEventDisplay._def.extendedProps;
    await downloadCalendarFilingAttachment(
      attachmentId,
      fileTrackingId,
      customerId,
      fileName
    );
  };

  const handleAddAttachment = async () => {
    setShowError(false);
    setShowSuccess(false);
    if (!selectedFile) {
      setAlertMessage("Please select a file.");
      setShowError(true);
      setShowSuccess(false);
    } else {
      try {
        setIsLoading(true);
        const { fileTrackingId, customerId } =
          selectedTrackerCalendarEventDisplay._def.extendedProps;
        let payload = {
          Files: selectedFile,
          fileTrackingId: fileTrackingId ? fileTrackingId + "" : "0",
          createUser: authUser?.userId + "",
        };
        let res = await createCalendarFilingAttachment(payload, customerId);
        console.log("handleAddAttachment res", res);

        if (res) {
          fetchCalendarEventAttachment();
          setAlertMessage("Attachment has been added");
          setShowError(false);
          setShowSuccess(true);
        }
        const form = document.getElementById("uploadForm");
        form.reset();
      } catch (error) {
        console.log(`Error while adding attachment`, error);
        setAlertMessage("`Error while adding attachment");
        setShowError(true);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleDelete = async (item) => {
    setSelectAttachment(item);
    showDialog(
      "Confirmation",
      "Are you sure to delete the attachment?",
      "confirm"
    );
  };

  const deleteAttachmentBlob = async () => {
    closeDialog();
    const { fileTrackingId, customerId } =
      selectedTrackerCalendarEventDisplay._def.extendedProps;

    let res = await deleteCalendarFilingAttachment(
      selectAttachment.attachmentId,
      customerId,
      fileTrackingId
    );
    if (res) {
      fetchCalendarEventAttachment();
      setAlertMessage("Successfully deleted attachment");
      setShowSuccess(true);
    }
  };

  const fetchCalendarEventAttachment = async () => {
    setAttachmentList([]);
    const { fileTrackingId } =
      selectedTrackerCalendarEventDisplay._def.extendedProps;
    try {
      const res = await fetchCalendarFilingAttachments(fileTrackingId);
      // console.log("fetchCalendarEventAttachment res", res);
      setAttachmentList(res);
    } catch (err) {
      console.log("fetchCalendarEventAttachment err", err);
    }
  };

  useEffect(() => {
    fetchCalendarEventAttachment();
  }, []);

  const {
    AlertDialog: ConfirmDialog,
    showDialog,
    closeDialog,
  } = useDialog({
    onSubmit: deleteAttachmentBlob,
    onClose: closeConfirm,
  });

  return (
    <Fragment>
      <Accordion
        disableGutters
        elevation={0}
        square
        onChange={handleChange}
        sx={{
          borderRadius: "12px",
          overflow: "hidden",

          border: "none", // ❌ remove full border
          borderBottom: "1px solid #e0e0e0", // ✅ only bottom border

          "&:before": {
            display: "none", // remove default MUI divider
          },
        }}
      >
        <AccordionSummary
          expandIcon={
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                backgroundColor: primaryColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontSize: "18px",
              }}
            >
              {expanded ? "−" : "+"}
            </div>
          }
          sx={{
            backgroundColor: "#f5f6fa",
            minHeight: "56px",
            padding: "0 16px",
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
          <Typography
            style={{
              fontSize: "0.9rem",
              fontWeight: "bold",
            }}
          >
            Final Attachment
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <form
              method="post"
              id="uploadForm"
              onChange={(event) => onFileChange(event)}
              style={{ margin: "1rem" }}
            >
              <div className='field'>
                <label className="file-upload">
                  <TrackNowTextField
                    type='file'
                    name='file'
                    id='inFile'
                  //  disabled={!draftSubmitted}
                  />
                </label>
              </div>
            </form>
            <div
              style={{
                margin: "1rem",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <TrackNowButton
                size="small"
                variant="tertiary"
                //   disabled={IsDisabled()}
                disabled={isLoading}
                onClick={() => handleCancel()}
              >
                Clear
              </TrackNowButton>
              <TrackNowButton
                size="small"
                variant="primary"
                type="submit"
                disabled={isLoading}
                onClick={() => handleAddAttachment()}
              >
                Attach File
              </TrackNowButton>
            </div>
            {showError && <Alert severity="error">{alertMessage}</Alert>}
            {showSuccess && <Alert severity="success">{alertMessage}</Alert>}
          </div>
          <DataTable
            size="small"
            scrollable
            scrollHeight="200px"
            value={attachmentList}
            dataKey="attachmentId"
            style={{ fontSize: "0.8rem" }}
          >
            <Column
              field="createUser"
              header="Created By"
              body={(rowData) => getUserName(rowData.createUser)}
            ></Column>
            <Column
              field="createDate"
              header="Created Date"
              body={(rowData) =>
                toLocalDateTime && toLocalDateTime(rowData.createDate)
              }
            ></Column>
            <Column
              field="attachmentPath"
              header="Attachment"
              body={renderAttachment}
            ></Column>
            <Column
              header="Action"
              style={{ textAlign: "center" }}
              body={(rowData) => (
                <Delete
                  rowData={rowData}
                  onClick={() => handleDelete(rowData)}
                />
              )}
            ></Column>
          </DataTable>
        </AccordionDetails>
      </Accordion>
      {<ConfirmDialog />}
    </Fragment>
  );
};

export default CalendarDetailsAttachment;
